import { Link } from "react-router-dom";
import { memeItems } from "@/mocks/memes";

const commentWall = memeItems
  .flatMap((item) =>
    item.comments.map((comment) => ({ ...comment, sourceTitle: item.title, sourceId: item.id })),
  )
  .sort((a, b) => b.likes - a.likes)
  .slice(0, 9);

export default function CommentWall() {
  return (
    <section className="w-full bg-accent-50">
      <div className="mx-auto w-full px-4 py-14 md:px-8 md:py-20">
        <div className="max-w-2xl">
          <span className="text-xs tracking-[0.2em] text-accent-800">COMMENTS</span>
          <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">评论区比正文还好笑</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
            这些是从各条内容底下捞出来的高赞发言。有时候一张图好笑，是因为配词的人更会说话。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {commentWall.map((comment, index) => (
            <blockquote
              key={`${comment.sourceId}-${index}`}
              className="flex h-full flex-col rounded-lg border border-accent-200 bg-background-50 p-5"
            >
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                <i className="ri-double-quotes-l text-lg"></i>
              </span>
              <p className="mt-4 flex-1 text-sm leading-relaxed text-foreground-900">{comment.text}</p>
              <footer className="mt-5 flex items-center justify-between border-t border-background-200 pt-4 text-xs">
                <span className="flex items-center gap-2">
                  <span className="flex h-7 w-7 items-center justify-center rounded-full bg-secondary-100 text-secondary-900">
                    {comment.user.slice(0, 1)}
                  </span>
                  <span className="text-foreground-700">{comment.user}</span>
                </span>
                <span className="flex items-center gap-1 text-foreground-500">
                  <i className="ri-thumb-up-line text-accent-600"></i>
                  {comment.likes}
                </span>
              </footer>
              <Link
                to={`/meme/${comment.sourceId}`}
                className="mt-3 flex items-center gap-1 text-xs text-primary-600 transition-colors hover:text-primary-700"
              >
                来自《{comment.sourceTitle}》
                <span className="flex h-3.5 w-3.5 items-center justify-center">
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </Link>
            </blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}